export default __webpack_public_path__ + "media/images/home/slide_summer_break_2026_sm-c5dbcdde94e551b69a428f0ace45b470.jpg";